export const colors = {
  primary: {
    main: '#76AEDE',
    light: '#A1C3E8',
    dark: '#5A9BD4',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#EE86B4',
    light: '#F2A5C8',
    dark: '#D16FA0',
    contrastText: '#ffffff',
  },
  success: {
    main: '#9DC214',
    light: '#B8D555',
    dark: '#7BA010',
    contrastText: '#ffffff',
  },
  warning: {
    main: '#F6AC1D',
    light: '#F8BD4D',
    dark: '#E09A0A',
    contrastText: '#ffffff',
  },
  error: {
    main: '#dc3545',
    light: '#f8d7da',
    dark: '#c82333',
    contrastText: '#ffffff',
  },
  // Custom colors for your specific use cases
  custom: {
    cardBorder: '#e9ecef',
    textSecondary: '#6c757d',
    backgroundLight: '#f8f9fa',
    backgroundGradient: 'linear-gradient(135deg, #fafbfc 0%, #ffffff 100%)',
  }
};